import { useState } from "react";
import { Mail, Check } from "lucide-react";
import { useLang } from "../i18n";
import api, { formatApiError } from "../api";
import Reveal from "./Reveal";

const NewsletterForm = () => {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/newsletter", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20" data-testid="newsletter-section">
      <Reveal>
        <div className="relative rounded-2xl border border-viola/40 bg-viola/5 overflow-hidden p-10 sm:p-14 text-center">
          <div className="orb absolute -top-20 -right-20 w-72 h-72 rounded-full bg-viola/25" />
          <Mail className="w-8 h-8 text-viola mx-auto mb-5" />
          <p className="font-mono2 text-xs tracking-[0.35em] uppercase text-viola mb-4">{t("nl_kicker")}</p>
          <h2 className="font-display font-bold text-2xl sm:text-4xl tracking-tight mb-4">{t("nl_title")}</h2>
          <p className="text-mist max-w-lg mx-auto text-sm sm:text-base mb-8">{t("nl_sub")}</p>
          {done ? (
            <p className="inline-flex items-center gap-2 text-gold font-semibold" data-testid="newsletter-success">
              <Check className="w-5 h-5" /> {t("nl_done")}
            </p>
          ) : (
            <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input
                data-testid="newsletter-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("nl_placeholder")}
                className="flex-1 rounded-full border border-white/15 bg-black/50 px-5 py-3.5 text-sm placeholder:text-mute focus:border-viola focus:outline-none transition-colors"
              />
              <button
                data-testid="newsletter-submit-button"
                disabled={busy}
                className="rounded-full bg-viola px-7 py-3.5 text-sm font-semibold uppercase tracking-wider text-white hover:bg-ember transition-colors disabled:opacity-50"
              >
                {t("nl_btn")}
              </button>
            </form>
          )}
          {error && <p className="text-sm text-red-400 mt-4" data-testid="newsletter-error">{error}</p>}
          <p className="font-mono2 text-[10px] tracking-wider text-mute mt-6 uppercase">{t("nl_privacy")}</p>
        </div>
      </Reveal>
    </section>
  );
};

export default NewsletterForm;
